import React, { Component } from "react";
import "../style/documents.scss";

export default class Documents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: "",
      isLoading: false,
      data: [],
      breadcrumbs: [{ text: "Home", id: "18LCYYx_JKDVi2mes1JHBN_h_Pgso0gSW" }],
    };
  }
  componentDidMount() {
    this.handleNavigate();
  }

  handleBreadcrumb = (crumb, index) => {
    let breadcrumbs = this.state.breadcrumbs;
    let i = breadcrumbs.length;
    while (i > index + 1) {
      breadcrumbs.pop();
      i--;
    }
    this.setState({
      ...this.state,
      breadcrumbs,
    });
    this.handleNavigate(crumb.id);
  };

  addBreadcrumb = (id, title) => {
    let breadcrumbs = this.state.breadcrumbs;
    breadcrumbs.push({ id, text: title });
    this.setState({
      ...this.state,
      breadcrumbs,
    });
    this.handleNavigate(id);
  };

  handleNavigate = (id = "18LCYYx_JKDVi2mes1JHBN_h_Pgso0gSW") => {
    this.setState({
      ...this.state,
      isLoading: true,
    });
    fetch(
      "https://www.googleapis.com/drive/v2/files?q='" +
        id +
        "'+in+parents&key=AIzaSyBZJ5qkJ-1rMAqvaW6XlfWxOcuJPCj1Q9g"
    )
      .then((res) => res.json())
      .then((res) => {
        let folders = res.items.filter((item) => {
          return item.mimeType === "application/vnd.google-apps.folder";
        });
        let files = res.items
          .filter((item) => {
            return item.mimeType !== "application/vnd.google-apps.folder";
          })
          .map((file) => {
            return {
              thumbnail: file.iconLink,
              name: file.title,
              url: file.webContentLink,
              id: file.id,
            };
          });
        this.setState({
          ...this.state,
          files,
          folders,
          isLoading: false,
        });
      });
  };

  downloadFile = (url) => {
    window.location = url;
  };

  render() {
    let folders = this.state.folders;
    let files = this.state.files;
    let breadcrumbs = this.state.breadcrumbs;
    let isLoading = this.state.isLoading;
    return (
      <div className="documents">
        <div className="container">
          <div className="row">
            {breadcrumbs &&
              breadcrumbs.map((crumb, index) => {
                return (
                  <button
                    className="breadcrumb"
                    key={crumb.id}
                    onClick={() => this.handleBreadcrumb(crumb, index)}
                  >
                    {crumb.text}
                  </button>
                );
              })}
          </div>
          {isLoading && isLoading === true ? (
            <div className="progress">
              <div className="indeterminate" />
            </div>
          ) : (
            ""
          )}

          <div className="row">
            <h3>Folders</h3>
            <table className="responsive-table">
              <tbody>
                {folders && folders.length > 0 ? (
                  folders.map((folder) => {
                    return (
                      <tr
                        key={folder.id}
                        onClick={() =>
                          this.addBreadcrumb(folder.id, folder.title)
                        }
                      >
                        <td>
                          <img
                            src={folder.iconLink}
                            alt="An icon of a folder"
                          />
                        </td>
                        <td>{folder.title}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td className="h4">No folders</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="row">
            <h3>Files</h3>
            <table className="responsive-table">
              <tbody>
                {files && files.length > 0 ? (
                  files.map((file) => {
                    return (
                      <tr
                        key={file.id}
                        onClick={() => this.downloadFile(file.url)}
                      >
                        <td>
                          <img src={file.thumbnail} alt="An icon of a folder" />
                        </td>
                        <td>{file.name}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td>No files</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
